module.exports = __webpack_public_path__ + "img/nathalie_de_loeper.bee4d4d9.jpg";